/* eslint-disable */
import schemaAustralianPassport from "@/schemas/identities/identityAustralianPassport";
import schemaBirthCertificate from "@/schemas/identities/identityBirthCertificate";
import schemaCitizenshipCertificate from "@/schemas/identities/identityCitizenshipCertificate";
import schemaImmiCard from "@/schemas/identities/identityImmiCard";
import schemaMedicareCard from "@/schemas/identities/identityMedicareCard";

import schemaDriversLicenceNsw from "@/schemas/identities/identityDriversLicenceNsw";
import schemaDriversLicenceQld from "@/schemas/identities/identityDriversLicenceQld";
import schemaDriversLicenceNt from "@/schemas/identities/identityDriversLicenceNt";
import schemaDriversLicenceWa from "@/schemas/identities/identityDriversLicenceWa";
import schemaDriversLicenceSa from "@/schemas/identities/identityDriversLicenceSa";
import schemaDriversLicenceVic from "@/schemas/identities/identityDriversLicenceVic";
import schemaDriversLicenceTas from "@/schemas/identities/identityDriversLicenceTas";
import schemaDriversLicenceAct from "@/schemas/identities/identityDriversLicenceAct";

import schemaDriversLicence from "@/schemas/identities/identityDriversLicence";
import schemaVisa from "@/schemas/identities/identityVisa";
import schemaCentrelinkCard from "@/schemas/identities/identityCentrelinkCard";


export const STATES = [
  {
    text: "ACT",
    value: "ACT"
  },
  {
    text: "NSW",
    value: "NSW"
  },
  {
    text: "NT",
    value: "NT"
  },
  {
    text: "SA",
    value: "SA"
  },
  {
    text: "QLD",
    value: "QLD"
  },
  {
    text: "TAS",
    value: "TAS"
  },
  {
    text: "VIC",
    value: "VIC"
  },
  {
    text: "WA",
    value: "WA"
  }
];

export const DEVELOPMENT_OPTIONS = [
  {
    text: "Always",
    value: "always"
  },
  {
    text: "Usually",
    value: "usually"
  },
  {
    text: "Sometimes",
    value: "sometimes"
  },
  {
    text: "Needs support",
    value: "needs-support"
  }
];

export const STATUSES = [
  {
    text: "In progress",
    value: "inprogress",
    icon: "circleArrow",
    colour: "#ffcc3d"
  },
  {
    text: "Complete",
    value: "complete",
    icon: "circleCheck",
    colour: "#13ce66"
  },
  {
    text: "Sent",
    value: "sent",
    icon: "circlePadlock",
    colour: "#041e42"
  },
  {
    text: "Archived",
    value: "archived",
    icon: "archive",
    colour: "#041e42"
  },
  {
    text: "Deleted",
    value: "deleted",
    icon: "times",
    colour: "#ce0037"
  },
  {
    text: "Awaiting Consent",
    value: "awaiting-consent",
    icon: "circlePadlock",
    colour: "#ce0037"
  },
  {
    text: "Consent Received",
    value: "consent-received",
    icon: "consentReceivedIcon",
    colour: "#13ce66"
  },
];

export const IDENTITY_OPTIONS = [
  {
    value: "passportdvs",
    text: "Australian passport",
    schema: schemaAustralianPassport
  },
  {
    value: "birthcertificatedvs",
    text: "Australian birth certificate",
    schema: schemaBirthCertificate
  },
  {
    value: "citizenshipcertificatedvs",
    text: "Australian citizenship certificate",
    schema: schemaCitizenshipCertificate
  },
  {
    value: "immicarddvs",
    text: "ImmiCard",
    schema: schemaImmiCard
  },
  {
    value: "medicaredvs",
    text: "Medicare card",
    schema: schemaMedicareCard
  },
  {
    value: "visadvs",
    text: "Australian visa (foreign passports)",
    schema: schemaVisa
  },
  {
    value: "centrelinkdvs",
    text: "Centrelink concession card",
    schema: schemaCentrelinkCard
  },
  {
    value: "regodvs",
    text: "Australian driver licence",
    schema: schemaDriversLicence,
    options: [
      {
        value: "actregodvs",
        schema: schemaDriversLicenceAct
      },
      {
        value: "nswregodvs",
        schema: schemaDriversLicenceNsw
      },
      {
        value: "ntregodvs",
        schema: schemaDriversLicenceNt
      },
      {
        value: "saregodvs",
        schema: schemaDriversLicenceSa
      },
      {
        value: "qldregodvs",
        schema: schemaDriversLicenceQld
      },
      {
        value: "tasregodvs",
        schema: schemaDriversLicenceTas
      },
      {
        value: "vicregodvs",
        schema: schemaDriversLicenceVic
      },
      {
        value: "waregodvs",
        schema: schemaDriversLicenceWa
      }
    ]
  }
];
